<script setup>
import { mapState } from "vuex";
</script>
<template>
  <b-nav class="nav-toggled">
    <b-nav-item-dropdown no-caret :text="$t('relatorios-navbar')" class="toggled" id="relatorios" left>
      <b-dropdown-item id="botaoRelatoriosIndicadores" class="drop-item" :to="`/viewInfluenceTree`"
        v-if="user.Permissions.visualizargestaoindicadores && user.Permissions.visualizargestaoindicadores.allowed && user.Permissions.visualizargestaoindicadores.permission">
        <img class="dropItem" src="@/assets/dashboard2.png" alt="Relatórios Personalizados" />
        {{ user.Permissions.visualizargestaoindicadores.permission }}
      </b-dropdown-item>

      <b-dropdown-item id="botaoRelatoriosPersonalizados" class="drop-item" :to="`/relatoriospersonalizados`"
        v-if="user.Permissions.visualizargestaorelatorios && user.Permissions.visualizargestaorelatorios.allowed && user.Permissions.visualizargestaorelatorios.permission">
        <img class="dropItem" src="@/assets/Planejamento.png" alt="Relatórios Personalizados" />
        {{ user.Permissions.visualizargestaorelatorios.permission }}
      </b-dropdown-item>

      <b-dropdown-item id="botaoHistoricoRto" class="drop-item" :to="`/rtohistory`"
        v-if="user.Permissions.rtoconfigurar && user.Permissions.rtoconfigurar.allowed">
        <img class="dropItem" src="@/assets/dashboard2.png" alt="Histórico RTO" />
        Histórico RTO
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </b-nav>
</template>
<script>
export default {
  name: 'ReportDropdown',
  computed: mapState(["user"]),
}

</script>
<style scoped>
img.Item {
  max-height: 37px;
  max-width: 37px;
  border-radius: 5px;
  margin: auto;
}

img.dropItem {
  max-height: 25px;
  max-width: 25px;
  border-radius: 5px;
  margin-right: 10px;
}

.dropdown-menu {
  height: auto;
  max-height: 350px;
  overflow-y: auto;
}

.ilink {
  margin-right: 10px;
}

.txt {
  color: white;
  padding: 10px 20px;
}
</style>